<template>
  <div class="aviation-calculator-edit">
    <div class="editor-header">
      <div class="header-title">
        <h2>
          <i class="bx bxs-plane-take-off"></i>
          Редактор калькулятора авиаперевозок
        </h2>
        <div v-if="updatedAt" class="last-updated">
          <i class="bx bx-time"></i>
          Последнее обновление: {{ formatDate(updatedAt) }}
        </div>
      </div>
      <div class="editor-actions">
        <button 
          class="btn btn-secondary"
          @click="$emit('close-editor')"
        >
          <i class="bx bx-x"></i>
          Закрыть редактор
        </button>
        <!-- <button 
            class="btn btn-success"
            @click="addTariff"
          >
            <i class="bx bx-plus"></i>
            Добавить тариф
        </button> -->
        <button 
          class="btn btn-primary"
          @click="saveCalculator"
          :disabled="isSaving"
        >
          <i class="bx bx-save"></i>
          {{ isSaving ? 'Сохранение...' : 'Сохранить' }}
        </button>
      </div>
    </div>
    
    <div class="editor-content">
      <div class="tariffs-section">
        <div class="tariffs-table-container">
          <!-- Сообщение когда нет тарифов -->
          <div v-if="tariffs.length === 0" class="empty-tariffs-message">
            <i class="bx bx-info-circle"></i>
            <p>Пока нет данных о тарифах</p>
          </div>
          
          <!-- Таблица тарифов -->
          <table v-else class="tariffs-table">
            <thead>
              <tr>
                <th>Название тарифа</th>
                <th>Код тарифа</th>
                <th>Доставка до аэропорта (дни)</th>
                <th>Экспортное ТО (дни)</th>
                <th>Вылетов в неделю</th>
                <th>Итого дней доставки</th>
                <th style="min-width: 80px;">45 кг</th>
                <th style="min-width: 80px;">100 кг</th>
                <th style="min-width: 80px;">300 кг</th>
                <th style="min-width: 80px;">Pick up за кг</th>
                <th style="min-width: 80px;">Pick up MIN FIX</th>
                <th style="min-width: 80px;">FIX EXW CC</th>
                <th style="min-width: 80px;">Per Kg TH</th>
                <th style="min-width: 80px;">FIX MIN TH</th>
                <th style="min-width: 80px;">FIX AWB</th>
                <th style="min-width: 80px;">FIX BASE</th>
                <!-- <th style="text-align: center;">Действия</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tariff, index) in tariffs" :key="index">
                <td>
                  <input 
                    v-model="tariff.name" 
                    type="text" 
                    class="form-control"
                    placeholder="Название тарифа"
                  />
                </td>
                <td>
                  <input 
                    v-model="tariff.tariff_code" 
                    type="text" 
                    class="form-control"
                    placeholder="A"
                    maxlength="1"
                  />
                </td>
                <td>
                  <input 
                    v-model="tariff.delivery_days_to_airport" 
                    type="text" 
                    class="form-control"
                    placeholder="1"
                  />
                </td>
                <td>
                  <input 
                    v-model="tariff.export_customs_days" 
                    type="text" 
                    class="form-control"
                    placeholder="1"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.flights_per_week" 
                    type="number" 
                    class="form-control"
                    placeholder="7"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model="tariff.total_delivery_days" 
                    type="text" 
                    class="form-control"
                    placeholder="2-5"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.weight_45" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.weight_100" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.weight_300" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.pickup_per_kg" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.pickup_min_fix" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.fix_exw_cc" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.per_kg_th" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.fix_min_th" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.fix_awb" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td>
                  <input 
                    v-model.number="tariff.pricing.fix_base" 
                    type="number" 
                    class="form-control"
                    step="0.01"
                    min="0"
                  />
                </td>
                <!-- <td style="text-align: center;">
                  <button 
                    v-if="!tariff.is_default"
                    class="btn btn-danger btn-sm"
                    @click="removeTariff(index)"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                  <span v-else class="text-muted">Системный</span>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_CALCULATOR_SETTINGS_AVIATION } from '@/constants'

export default {
  name: 'AviationCalculatorEdit',
  
  data() {
    return {
      isSaving: false,
      isLoading: true,
      tariffs: [],
      updatedAt: null
    }
  },
  
  async mounted() {
    await this.loadSettings()
  },
  
  methods: {
    async loadSettings() {
      try {
        this.isLoading = true
        const response = await axios.get(API_CALCULATOR_SETTINGS_AVIATION)
        
        if (response.data.success && response.data.data.tariffs) {
          // Добавляем флаг is_default для загруженных тарифов
          this.tariffs = response.data.data.tariffs.map(tariff => ({
            ...tariff,
            is_default: tariff.is_default !== undefined ? tariff.is_default : false
          }))
          this.updatedAt = response.data.updated_at
        } else {
          this.tariffs = []
          this.updatedAt = null
        }
      } catch (error) {
        console.error('Ошибка загрузки настроек:', error)
        this.tariffs = []
        this.$toast.error('Ошибка загрузки настроек калькулятора')
      } finally {
        this.isLoading = false
      }
    },
    
    
    addTariff() {
      this.tariffs.push({
        name: '',
        tariff_code: '',
        delivery_days_to_airport: '',
        export_customs_days: '',
        flights_per_week: 0,
        total_delivery_days: '',
        is_default: false,
        pricing: {
          weight_45: 0,
          weight_100: 0,
          weight_300: 0,
          pickup_per_kg: 0,
          pickup_min_fix: 0,
          fix_exw_cc: 0,
          per_kg_th: 0,
          fix_min_th: 0,
          fix_awb: 0,
          fix_base: 0
        }
      })
    },
    
    removeTariff(index) {
      this.tariffs.splice(index, 1)
    },
    
    async saveCalculator() {
      try {
        this.isSaving = true
        
        const settings = {
          tariffs: this.tariffs
        }
        
        const response = await api.call('put', API_CALCULATOR_SETTINGS_AVIATION, { settings })
        
        if (response.data.success) {
          this.updatedAt = response.data.updated_at
          this.$toast.success('Калькулятор авиаперевозок успешно сохранен')
        } else {
          this.$toast.error(response.data.message || 'Ошибка сохранения')
        }
      } catch (error) {
        console.error('Ошибка сохранения:', error)
        this.$toast.error('Ошибка сохранения настроек калькулятора')
      } finally {
        this.isSaving = false
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.aviation-calculator-edit {
  overflow: hidden;
  
  .editor-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 15px 0px 30px 0;
    
    .header-title {
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      h2 {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        color: #0d6348;
        
        i {
          font-size: 28px;
        }
      }
      
      .last-updated {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #6c757d;
        font-style: italic;
        
        i {
          font-size: 14px;
        }
      }
    }
    
    .editor-actions {
      display: flex;
      gap: 8px;
      
      .btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border: none;
        border-radius: 4px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 12px;
        
        i {
          font-size: 14px;
        }
        
        &.btn-primary {
          background: #e37926;
          color: white;
          border: 1px solid #d16a1a;
          
          &:hover:not(:disabled) {
            background: #d16a1a;
          }
          
          &:disabled {
            background: rgba(227, 121, 38, 0.6);
            cursor: not-allowed;
          }
        }
        
        &.btn-secondary {
          background: transparent;
          color: #0d6348;
          border: 1px solid #0d6348;
          
          &:hover {
            background: #0d6348;
            color: white;
          }
        }      }
    }
  }
  
  .editor-content {
    .tariffs-section {
        h3 {
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 0 0 15px 0;
          color: #0d6348;
          font-size: 18px;
          font-weight: 600;
          
          i {
            font-size: 20px;
          }
        }
      
      .tariffs-table-container {
        overflow-x: auto;
        margin-bottom: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        
        .empty-tariffs-message {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 6px;
          color: #6c757d;
          
          i {
            font-size: 36px;
            margin-bottom: 12px;
            color: #0d6348;
          }
          
          p {
            margin: 0;
            font-size: 14px;
            font-weight: 500;
          }
        }
        
        .tariffs-table {
          width: 100%;
          border-collapse: collapse;
          background: #fff;
          min-width: 1200px;
          
          th {
            background: #0d6348;
            color: white;
            font-weight: 600;
            padding: 8px 6px;
            text-align: left;
            border: 1px solid #0a4d3a;
            font-size: 11px;
            white-space: nowrap;
          }
          
          td {
            padding: 4px 6px;
            border: 1px solid #dee2e6;
            vertical-align: middle;
            
            .form-control {
              width: 100%;
              padding: 4px 6px;
              border: 1px solid #ced4da;
              border-radius: 3px;
              font-size: 11px;
              
              &:focus {
                outline: none;
                border-color: #0d6348;
                box-shadow: 0 0 0 2px rgba(13, 99, 72, 0.25);
              }
            }
            
            .btn {
              padding: 3px 6px;
              font-size: 11px;
              border-radius: 3px;
              
              &.btn-danger {
                background: #dc3545;
                color: white;
                border: none;
                
                &:hover {
                  background: #c82333;
                }
              }
            }
            
            .text-muted {
              color: #6c757d;
              font-size: 12px;
              font-style: italic;
            }
          }
          
          tr:nth-child(even) {
            background: #f8f9fa;
          }
          
          tr:hover {
            background: #e3f2fd;
          }
        }
      }
      
      .tariffs-actions {
        display: flex;
        justify-content: flex-end;
        
        .btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border: none;
          border-radius: 4px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 12px;
          
          &.btn-success {
            background: #0d6348;
            color: white;
            
            &:hover {
              background: #0a4d3a;
            }
          }
          
          i {
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .aviation-calculator-edit {
    .editor-header {
      flex-direction: column;
      gap: 15px;
      text-align: center;
      
      .editor-actions {
        width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>
